import { AppCoreEnums } from '../shared/enums';
import { Pagination } from '../../stores/core/models';
import { useCoreStore } from '../../stores/core/store';
import useUserPreferences from './use-user-preferences';
import { dispatchUpdatePaginationUserPreferenceIfNeeded } from '../../core/utils/user-preferences-utils';

const { getPaginationPreferenceKey } = useUserPreferences();

const updatePaginationStateData = (pagination: Pagination, containerType: AppCoreEnums.ContainerType) => {
  const coreStore = useCoreStore();

  switch (containerType) {
    case AppCoreEnums.ContainerType.CollapsibleTableContainer:
      coreStore.collapsibleTableContainerData.pagination = pagination;
      break;

    case AppCoreEnums.ContainerType.TableContainer:
      coreStore.tableContainerData.pagination = pagination;
      break;

    case AppCoreEnums.ContainerType.TableInnerContainer:
      coreStore.tableInnerContainerData.pagination = pagination;
      break;

    case AppCoreEnums.ContainerType.LogsTableContainer:
      coreStore.logsTableContainerPagination = pagination;
      break;

    case AppCoreEnums.ContainerType.DrawerContainer:
      coreStore.drawerContainerData.pagination = pagination;
      break;

    case AppCoreEnums.ContainerType.CollapsibleContainer:
      coreStore.collapsibleContainerData.pagination = pagination;
      break;
    
    case AppCoreEnums.ContainerType.ListContainer:
      coreStore.listContainerData.pagination = pagination;
      break;
  }

  dispatchUpdatePaginationUserPreferenceIfNeeded(getPaginationPreferenceKey(containerType), pagination);
};

export default updatePaginationStateData;
